var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1A1A1A",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.387 27",
    width: "32px",
    height: "32px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 2.643 0 C 1.184 0 0 1.182 0 2.641 C 0 4.1 1.183 5.309 2.641 5.309 C 4.099 5.309 5.283 4.1 5.283 2.641 C 5.283 1.183 4.102 0 2.643 0 Z M 15.535 7 C 13.316 7 12.047 8.16 11.438 9.314 L 11.373 9.314 L 11.373 7.311 L 7 7.311 L 7 22 L 11.557 22 L 11.557 14.729 C 11.557 12.813 11.701 10.961 14.072 10.961 C 16.409 10.961 16.443 13.146 16.443 14.85 L 16.443 22 L 20.994 22 L 21 22 L 21 13.932 C 21 9.984 20.151 7 15.535 7 Z M 0.363 7.311 L 0.363 22 L 4.924 22 L 4.924 7.311 L 0.363 7.311 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.9406f04c1bc35705313011fbabf8d6cd.svg";
export { ForwardRef as ReactComponent };